import { CSSProperties } from 'react';
import { Row } from '@tempmee/react';
import { InviteButton } from '../InviteButton';
import { IProfessionalCardUser } from '../../interfaces';

// ── inline styles (no DS prop equivalent) ──────────────────────────────────
/** marginLeft/marginRight have no DS Box prop (gap from the card's content edge) */
const actionsRowStyle: CSSProperties = { marginLeft: 24, marginRight: 30 };

interface IProfessionalCardActionsProps {
  user: IProfessionalCardUser;
}

export const ProfessionalCardActionsNew = ({ user }: IProfessionalCardActionsProps) => (
  <Row justify="center" align="center" style={actionsRowStyle}>
    <InviteButton
      user={{
        id: user?.id,
        image: user?.profileImage,
        name: user?.fullname,
        profession: user?.professions?.join(','),
        professions: user?.professions,
        isFavorite: true,
      }}
      disabled={!user?.isAvailable}
      source="favorites"
    />
  </Row>
);
